module.exports = __webpack_public_path__ + "img/conectada_02.e02204c4.svg";